import 'polyfills/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import HowWeCommunicatePage from 'components/Landing/HowWeCommunicatePage/HowWeCommunicatePage';

import { registerComponents } from '../src/registrations';

registerComponents({ HowWeCommunicatePage });
